export type SonarSortDirection = 'ascending' | 'descending' | 'Ascending' | 'Descending' | SonarV3SortDirection | null;
export enum SonarV3SortDirection {
	Ascending = 0,
	Descending = 1
}
